import { Tooltip } from '@buffer-mono/popcorn'
import type { TooltipProps } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

/*
 * It's a wrapper around the Tooltip component that conditionally renders the tooltip
 * based on the content prop.
 *
 * If the content prop is not provided, the component will render the children without a tooltip.
 *
 * If the content prop is provided, the component will render the children with a tooltip.
 */
export const ConditionalTooltip = ({
  ...props
}: TooltipProps & { className?: string }): JSX.Element => {
  const { children, className, ...tooltipProps } = props
  if (!tooltipProps.content) {
    return <>{children}</>
  }

  const { side = 'top', align = 'end', ...rest } = tooltipProps

  return (
    <Tooltip side={side} align={align} {...rest}>
      {/* The div is added to work around some issues with older Buttom components used in UpdateSaver */}
      <div className={className}>{children}</div>
    </Tooltip>
  )
}
